import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AbstractServicePublic } from './abstract.service.public';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractServicePrivate extends AbstractServicePublic {

  protected getBaseUrlPrivate(): string {

    return environment.url + '/private/';
  }
  
}
